import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { PrepaidSimState, Payload, Item } from '@/store/prepaidSim/state';

const count = (state: PrepaidSimState) => (payload: Payload) => {
  const targetList = find(state)(payload);
  const result = targetList.reduce((z, item, index, array) => {
    return (z += item.count);
  }, 0);
  return result;
};

const find = (state: PrepaidSimState) => (payload: Payload): Item[] => {
  return state.prepaidSim.filter(item => {
    return item && (payload.id ? item.id === payload.id : true);
  });
};

const getters: GetterTree<PrepaidSimState, RootState> = {
  count,
  find,
};

export default getters;
